// extracted by mini-css-extract-plugin
export default {"sideMenu":"Modal_sideMenu__9Ytrc","mainMenu":"Modal_mainMenu__1-T-e"};